'use client';

import { deleteProvider } from 'actions/Database';
import { DBProviders } from 'db/schema/providers';
import { useAppDispatch } from 'lib/hooks';
import { removeProvider } from 'slices/doctorSlice';
import styles from 'styles/sunfire.forms.module.css';
import { formatAddress } from 'utils/formatters';
import WarningCircleIcon from 'components/icons/WarningCircleIcon';
import DeleteIcon from 'components/icons/DeleteIcon';

interface SavedProviderProps {
  providers: DBProviders[];
}

const SavedProviderList = ({ providers }: SavedProviderProps) => {
  const dispatch = useAppDispatch();

  const handleDelete = async (provider: DBProviders) => {
    const removed = await deleteProvider(provider);
    dispatch(removeProvider({ ...removed, created_at: null }));
  };

  return (
    <div className={styles.listContainer}>
      <h3>Your Saved Providers ({providers.length})</h3>

      {providers.length === 0 ? (
        <div className={styles.emptyList}>
          <WarningCircleIcon size="small" />
          <span>You haven&rsquo;t saved any doctors or providers.</span>
        </div>
      ) : (
        <ul className={styles.savedList}>
          {providers.map((provider) => {
            return (
              <li key={provider.id}>
                <div>
                  <h3>{provider.name}</h3>
                  <p>
                    <b>{provider.specialties}</b>
                  </p>
                  <p>{formatAddress(provider)}</p>
                </div>
                <div className={styles.listButton}>
                  <button
                    className="button"
                    onClick={() => handleDelete(provider)}
                  >
                    <DeleteIcon />
                    Delete
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SavedProviderList;
